import { NavLink } from 'react-router-dom';
import Button from '../base/Button';
import { useState } from 'react';

const navItems = [
  { label: '云手机', path: '/' },
  { label: 'ARM 云', path: '/arm-cloud' },
];

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white/90 backdrop-blur-md shadow-sm fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <NavLink to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-br from-sky-500 to-emerald-400 rounded-md flex items-center justify-center">
              <i className="ri-cloud-line text-white text-lg"></i>
            </div>
            <span className="text-lg sm:text-xl font-bold text-gray-900">壹码云</span>
          </NavLink>

          {/* Desktop: Navigation + CTA */}
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <nav className="flex items-center space-x-6 lg:space-x-8">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `text-sm font-medium transition-colors duration-200 pb-1 border-b-2 ${
                      isActive
                        ? 'text-emerald-600 border-emerald-500'
                        : 'text-gray-600 border-transparent hover:text-gray-900 hover:border-gray-300'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>

            <div className="flex items-center space-x-2 lg:space-x-3">
              <Button variant="outline" size="sm" className="border-gray-300 text-gray-700 hover:bg-gray-50">
                登录
              </Button>
              <Button size="sm" className="bg-emerald-500 hover:bg-emerald-600">
                免费试用
              </Button>
            </div>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    `px-4 py-3 rounded-lg text-base font-medium transition-colors ${
                      isActive
                        ? 'text-emerald-600 bg-emerald-50'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <div className="flex flex-col space-y-2 pt-2 border-t border-gray-100">
              <Button variant="outline" className="w-full border-gray-300 text-gray-700 hover:bg-gray-50">
                登录
              </Button>
              <Button className="w-full bg-emerald-500 hover:bg-emerald-600">
                免费试用
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
